import { render, staticRenderFns } from "./LineClassDay.vue?vue&type=template&id=22e2253a&scoped=true&"
import script from "./LineClassDay.vue?vue&type=script&lang=js&"
export * from "./LineClassDay.vue?vue&type=script&lang=js&"
import style0 from "./LineClassDay.vue?vue&type=style&index=0&id=22e2253a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e2253a",
  null
  
)

export default component.exports